import env from './env'
//const PRO_URL = 'https://rtdc.gosmart.mn/mobCore'
// const PRO_URL = 'https://roadpay.mn/mobCore'
const PRO_URL = 'https://darkhan.gosmart.mn/mobCore'

export default env === '_development' ? DEV_URL : PRO_URL